export const HIDDEN_TEMPLATES_CATEGORY = 'HIDDEN';
export const SAVED_TEMPLATES_CATEGORY = 'Organization';
export const GLOBAL_TEMPLATES_CATEGORY = 'Global';

// Removes the order setted at the beginning of the category name.
export const getCategoryName = (category) => {
  const name = category.replace(/[0-9]/g, '').trim();
  if (name === 'Announcement Bars') {
    return 'Alerts';
  }
  return name;
};
